import classNames from 'clsx';

import styles from './AppStatusBar.module.css';

export interface AppStatusBarProps {
  /** The message to be displayed in the status bar. */
  message: string;
  /** Determines the color of the bar. */
  severity: 'info' | 'warning' | 'error';
}

/** A component to display a general status. */
export const AppStatusBar = ({ message, severity }: AppStatusBarProps) => (
  <div className={classNames(styles['app-status-bar'], styles[`app-status-bar--${severity.toLowerCase()}`])}>
    <p className={styles['app-status-bar__message']} dangerouslySetInnerHTML={{ __html: message }} />
  </div>
);
